// extracted by mini-css-extract-plugin
export default {"searchForm":"Search_searchForm__tSqPJ","searchWrapper":"Search_searchWrapper__U1eoN","searchIcon":"Search_searchIcon__ymQfH","input":"Search_input__ehP+r"};